<script>
import BarList from '../components/bar-list'
import CrmMotivoList from './crm-motivo-list'
import CrmOrigemList from './crm-origem-list'
import TemplateEmailList from './template-email-list'
import { apiORDS, apiORDSpost, urlORDS } from '../shared/api-functions'
import { SysVars } from '../main';

export default {
    data () {
        return {
            metadata: this.$store.getters.getEntities.metadata,
            activeTab: 0,
        }
    },

    components: {
        BarList, CrmOrigemList, CrmMotivoList, TemplateEmailList
    },

    computed: {
        tabs: function () {
            let tabs = []
            tabs = [
                { title: 'Motivos de Perda', icon: null },
                { title: 'Canais de Origem', icon: null },
                { title: 'Templates de Email', icon: null },
            ]
            return tabs
        },

        tabMotivo: function () {
            return this.activeTab == 0
        },

        tabOrigem: function () {
            return this.activeTab == 1
        },

        tabTemplate: function () {
            return this.activeTab == 2
        },

    },

    methods: {
        closeForm() {

        },

        changeTab (idx) {
            this.activeTab = idx
        },
        
    },

    created () {
    }

}

</script>

<template>
    <div>
        
        <tabs :tabs="tabs" :setActiveTab="activeTab" @onClickTab="changeTab"></tabs>

        <div class="nb-margin-top">
            <transition name="fade" mode="out-in" v-if="tabMotivo">
                <crm-motivo-list></crm-motivo-list>
            </transition>

            <transition name="fade" mode="out-in" v-if="tabOrigem">
                <crm-origem-list></crm-origem-list>
            </transition>

            <transition name="fade" mode="out-in" v-if="tabTemplate">
                <template-email-list></template-email-list>
            </transition>

        </div>

    </div>

</template>

<style>

</style>



// WEBPACK FOOTER //
// src/forms-crm/crm-config.vue